import { render, staticRenderFns } from "./ReSidebar.vue?vue&type=template&id=7d23f03f&scoped=true"
import script from "./ReSidebar.vue?vue&type=script&lang=js"
export * from "./ReSidebar.vue?vue&type=script&lang=js"
import style0 from "./ReSidebar.vue?vue&type=style&index=0&id=7d23f03f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23f03f",
  null
  
)

export default component.exports